import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/Style.scss';
import App from './views/App';
import reportWebVitals from './reportWebVitals';
import { DarkModeContextProvider } from './context/darkModeContext';
import { Provider} from 'react-redux';
import store from '../src/redux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <Provider store={store}>
            <App />
      </Provider>
    </DarkModeContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
